import React from "react";

import { switchCompanyURL } from "Dashboard/EmployerUrls";
import isIntuit from "Intuit/isIntuit";
import { Helmet } from "react-helmet";
import companyToken from "Utils/companyToken";
import { isPartner } from "Utils/isPartner";
import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { NavItem } from "Cobalt/NavItem";
import { Card } from "Common/Card";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { usePartnerContext } from "Common/PartnerContext";
import ThemeInstaller from "Common/ThemeInstaller";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

export default function Chrome({ children, title, headerContent }) {
  const showMultiPageFlow = isPartner();
  const { partner } = usePartnerContext();

  const renderNavBar = () => {
    const rightContent = [];
    if (companyToken()) {
      rightContent.push(
        <NavItem key="switchLink" eventKey="switchLink" href={isIntuit() ? `/intuit/router${switchCompanyURL}` : switchCompanyURL}>
          Switch Company
        </NavItem>,
      );
    }
    if (isIntuit()) {
      rightContent.push(
        <NavItem key="logOut" eventKey="logOut" href="/logout">
          <Icon icon="sign-out-alt" flavor="solid" mx={3} />
          Log out
        </NavItem>,
      );
    }

    /* TODO: need to pass siteConfig.branding to branding prop */
    return <ResponsiveTopBar branding={partner} collapseOnSelect={false} rightContent={rightContent} />;
  };

  return (
    <div>
      <Helmet titleTemplate="SimplyInsured - %s" title={title} defaultTitle="SimplyInsured" />

      {renderNavBar()}
      {headerContent && (
        <Grid mt={5} p={0}>
          {headerContent}
        </Grid>
      )}

      <Div className="min-h-dvh">
        <Grid componentClass={showMultiPageFlow ? "div" : Card} mt={showMultiPageFlow ? 0 : 5} p={0}>
          {children}
        </Grid>
      </Div>
      <Footer />
      <Heartbeat />
      <ThemeInstaller />
    </div>
  );
}
